import { useBrowserSpecs } from '../../../utils/useBrowserSpecs';
import { useGlobalModal } from '../../Modals';

const AssertBrowser = ({ children }) => {
  const { isInvalidBrowser, webgl } = useBrowserSpecs();
  const [, showModal] = useGlobalModal();

  const available = !isInvalidBrowser && !!webgl;

  if (!available) {
    showModal(1);
    return null;
  }

  return <>{children}</>;
};

export default AssertBrowser;
